import React from 'react';
import Translate from '../../../components/Translate';
import Money from '../../../components/Money';

var ActiveLimit = function ActiveLimit(_ref) {
  var id = _ref.id,
      amount = _ref.amount,
      currency = _ref.currency,
      period = _ref.period,
      type = _ref.type,
      onCancel = _ref.onCancel;
  return React.createElement(
    'div',
    { className: 'limit-info-container' },
    amount && React.createElement(
      'div',
      { className: 'active-limit-content signup', key: Math.random() },
      React.createElement(
        'div',
        { className: 'limit-name' },
        React.createElement(Translate, { id: 'label.type.' + type }),
        ', ',
        period
      ),
      React.createElement(
        'div',
        { className: 'active-limit-amount' },
        React.createElement(Money, { decimals: false, value: amount, currency: currency }),
        React.createElement(
          'a',
          {
            href: '#',
            onClick: function onClick(e) {
              e.preventDefault();
              onCancel(id);
            } },
          React.createElement(Translate, { id: 'action.cancel_limit' })
        )
      )
    )
  );
};

export { ActiveLimit };